import IssueDetailsModal from "./IssueDetailsModal";
export default IssueDetailsModal;
